/// <reference path="../header/interfaces.ts" />
/// <reference path="../typings/jquery/jquery.d.ts" />
/// <reference path="../typings/jquery/jquery.extensions.d.ts" />
/// <reference path="../common/interfaces.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Header;
    (function (Header) {
        var QueryString = (function () {
            function QueryString(location) {
                this.location = location;
            }
            QueryString.prototype.getQueryStringParameterValue = function (name) {
                if (!$.isNullOrUndefined(name)) {
                    name = name.toLowerCase();
                }
                return this.getQueryStringParameters()[name];
            };
            QueryString.prototype.getQueryStringParameters = function () {
                var search = /([^&=]+)=([^&]+)/g;
                var decodeFunction = function (s) { return decodeURIComponent(s.replace(/\+/g, " ")); };
                var query = this.location.search.slice(this.location.search.indexOf("?") + 1);
                var urlParams = {};
                var match;
                do {
                    match = search.exec(query);
                    if (match) {
                        urlParams[decodeFunction(match[1]).toLowerCase()] = decodeFunction(match[2]);
                    }
                } while (match);
                return urlParams;
            };
            return QueryString;
        }());
        Header.QueryString = QueryString;
    })(Header = TotalJobsGroup.Header || (TotalJobsGroup.Header = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));

//# sourceMappingURL=query-string-utils.js.map
